import { Box, Typography } from "@mui/material"
import { FsnHeader } from "@fusion/components/Header"
import { HeaderBoxStyle, HeaderLogoSwap } from "lib/styles/header"
import * as hooks from "lib/hooks"
import { Outlet } from "react-router-dom"

/**
 * Minimal layout for unauthorized users on the sector admin contact info page.
 * Renders the app header (title only, no menu or links) and the Outlet.
 */
export function RestrictedContactLayout(): React.JSX.Element {
	const theme = hooks.UseTheme().theme
	return (
		<>
			<Box
				data-test-selector="header-title"
				sx={[HeaderBoxStyle(theme), HeaderLogoSwap]}
			>
				<FsnHeader
					title="Manufacturing Central Containment"
					menuVisible={false}
				/>
			</Box>
			<Box sx={{ px: 3, pt: 4, pb: 2, textAlign: "center" }}>
				<Typography
					component="p"
					variant="h5"
					sx={{
						color: "error.main",
						fontWeight: "bold",
					}}
				>
					Your account currently does not have access to MCC.
				</Typography>
			</Box>
			<Outlet />
		</>
	)
}
